





















































import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'
import MiniCalendar from '@ui/Calendar/MiniCalendar'

settings =
  name: "EventPricingBox"

  vue:
    props: ['audienceListing', 'options', 'actions']

    components: {
      MiniCalendar,
    }

    data: ->
      selectedSegment: null

    computed:
      earliestAvailabilityWindows: ->
        windows = @audienceListing.availability_windows
        return windows unless @options?.initialDate
        earliestDate = dayjs(@options.initialDate).subtract(1, 'day')
        windows.filter((avWindow) => dayjs(avWindow.date).isAfter(earliestDate))

      showPartnershipPricing: ->
        !!@options?.showPartnershipPricing

      optionsForCalendar: ->
        options =
          selectable: false
          dayCellClassNames: @dayCellClassNames
          initialDate: new Date()
        options.initialDate = @options?.initialDate if @options?.initialDate
        options

      inventory: ->
        inventory = {}
        for key, space of @audienceListing.spaces
          inventory[key] = space if space.segment is @selectedSegment
        inventory

      listingSegments: ->
        spaces = Object.values (@audienceListing.spaces || {})
        spaces.sort @spaceSorter
        @distinct spaces, 'segment'

      bookNowCopy: ->
        bookings = @partnerBuy().bookings || {}
        listingIds = []
        listingIds = [...listingIds, ...Object.keys(bookings)]
        listingsCount = listingIds.length || 0
        copy = "Book 1 Listing Now!" if listingsCount is 1
        copy = "Book #{listingIds.length} Listings Now!" if listingsCount > 1
        copy ||= "Book Now!"
        copy

      hasSpaceSelected: ->
        bookings = @partnerBuy().bookings || {}
        !!Object.values(bookings).length

    mounted: ->
      @selectedSegment = @$route.query.segment if @$route.query.segment

    methods:
      hiBookNow: ->
        # @actions.addBookingSpace(space) for key, space of @inventory
        @actions.addBookingSpace Object.values(@inventory)[0] unless @hasSpaceSelected
        @storePartnerBuyToken()
        @navigate()

      dayCellClassNames: ({ date, isPast, ...args }) ->
        ['disabled']

      partnerBuy: -> { ...@getAppSession('partnerBuy', {}) }

      storePartnerBuyToken: ->
        data = @partnerBuy()
        data.token = @$route.query.buy_partnership
        @setAppSession 'partnerBuy', data

      navigate: ->
        if @partnerBuy().brandRep
          @$router.push({ name: 'CampaignCreatePage' })
        else
          @$router.push({ name: 'BrandRepCreatePage' })

      quantityForSpace: (space) ->
        { formatNumber } = @$options.filters

        switch space.type
          when 'product_sampling' then "min #{-1}"
          else 1

      spaceNameFor: (space) ->
        { formatShortSpaceType } = @$options.filters
        name = formatShortSpaceType(space.type)
        name += " #{space.size}" if space.type is 'onsite_space'
        name

      spacePriceFor: (space) ->
        { formatMoney } = @$options.filters

        switch space.type
          # when 'video_wall' then "$#{formatMoney(@priceForVideoWallInDollars(space))}"
          when 'product_sampling' then 'Varies'
          else "$#{formatMoney(parseInt(space.price_in_cents || '0') / 100)}"

      # priceForVideoWallInDollars: (space) -> PricingModel.priceForVideoWall @event, @$store.marketplace.standard_pricing_table
    #   minPriceForProductSamplingInDollars: (space) -> PricingModel.priceForProductSampling space.min_quantity, @event, @$store.marketplace.standard_pricing_table
    #   maxPriceForProductSamplingInDollars: (space) -> PricingModel.priceForProductSampling space.max_quantity, @event, @$store.marketplace.standard_pricing_table

      spaceSorter: (spaceA, spaceB) ->
        if spaceA.type isnt spaceB.type
          return -1 if spaceA.type is 'product_sampling'
          return 1 if spaceB.type is 'product_sampling'
        spaceA.segment.localeCompare spaceB.segment

    watch:
      audienceListing: ->
        return if @selectedSegment
        return unless @listingSegments.length
        @selectedSegment = @listingSegments[0]

      '$route.query.segment': (segment) ->
        @selectedSegment = segment if segment isnt @selectedSegment

      selectedSegment: (segment) ->
        return if segment and segment is @$route.query.segment
        query = { ...@$route.query, segment }
        @$router.replace { query }

export default VueOptions.vue settings
